// 기존 소스(완전 원본)
// if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
//   window.Eurus.loadedScript.add('recently-viewed.js');

//   requestAnimationFrame(() => {
//     document.addEventListener('alpine:init', () => {
//       Alpine.store('xProductRecently', {
//         show: false,
//         productsToShow: 0,
//         productsToShowMax: 10,
//         init() {
//           if (document.getElementById('shopify-section-recently-viewed')) {
//             this.productsToShow = document.getElementById('shopify-section-recently-viewed').getAttribute("x-products-to-show");
//           }
//         },
//         showProductRecently() {
//           if (localStorage.getItem("recently-viewed")?.length) {
//             this.show = true;
//           } else {
//             this.show = false;
//           }
//         },

//         setProduct(productViewed) {
//           let productList = [];
//           if (localStorage.getItem("recently-viewed")?.length) {
//             productList = JSON.parse(localStorage.getItem("recently-viewed")); 
//             productList = [...productList.filter(p => p !== productViewed)].filter((p, i) => i<this.productsToShowMax);
//             this.show = true;
//             let newData = [productViewed, ...productList];
//             localStorage.setItem('recently-viewed', JSON.stringify(newData))
//           } else {
//             this.show = false;
//             localStorage.setItem('recently-viewed', JSON.stringify([productViewed]));
//           }
//         },
//         getProductRecently(sectionId, productId) {
//           let products = [];
//           if (localStorage.getItem("recently-viewed")?.length) {
//             products = JSON.parse(localStorage.getItem("recently-viewed"));
//             products = productId ? [...products.filter(p => p !== productId)] : products;
//             products = products.slice(0,this.productsToShow);
//           } else {
//             return;
//           }
//           const el = document.getElementById("shopify-section-recently-viewed");
//           let query = products.map(value => "id:" + value).join(' OR ');
//           var search_url = `${Shopify.routes.root}search?section_id=${ sectionId }&type=product&q=${query}`;
//           fetch(search_url).then((response) => {
//             if (!response.ok) {
//               var error = new Error(response.status);
//               console.log(error)
//               throw error;
//             }
    
//             return response.text();
//           })
//           .then((text) => {
//             const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('shopify-section-recently-viewed').innerHTML;
//             el.innerHTML = resultsMarkup;
//           })
//           .catch((error) => {
//             throw error;
//           });
//         },
//         clearStory() {
//           var result = confirm('Are you sure you want to clear your recently viewed products?');
//           if (result === true) {
//             localStorage.removeItem("recently-viewed");
//             this.show = false;
//           }
//         }
//       })
//     })
//   });
// }



// b7 - cart 전체페이지 비었을때 recently-viewed 섹션 삭제하기
if (!window.Eurus.loadedScript.has('recently-viewed.js')) {
  window.Eurus.loadedScript.add('recently-viewed.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecently', {
        show: false,
        productsToShow: 0,
        productsToShowMax: 10,

        init() {
          const section = document.getElementById('shopify-section-recently-viewed');

          if (section) {
            this.productsToShow = section.getAttribute('x-products-to-show');
          }
        },

        async showProductRecently() {
          const hasRecentlyViewed = localStorage.getItem('recently-viewed')?.length;

          if (!hasRecentlyViewed) {
            this.hideRecentlyViewed();
            return;
          }

          if (window.location.pathname.includes('/cart')) {
            const res = await fetch('/cart.js');
            const cart = await res.json();

            if (cart.item_count > 0) {
              this.show = true;
            } else {
              this.hideRecentlyViewed();
            }

            return;
          }

          this.show = true;
        },

        hideRecentlyViewed() {
          this.show = false;

          const section = document.getElementById('shopify-section-recently-viewed');
          const wrapper = document.querySelector('.section-recently-viewed');

          if (section) {
            section.style.display = 'none';
          }

          if (wrapper) {
            wrapper.style.display = 'none';
          }
        },

        setProduct(productViewed) {
          let productList = [];

          if (localStorage.getItem('recently-viewed')?.length) {
            productList = JSON.parse(localStorage.getItem('recently-viewed'));
            productList = [...productList.filter(p => p !== productViewed)].filter((p, i) => i < this.productsToShowMax);
            this.show = true;

            let newData = [productViewed, ...productList];
            localStorage.setItem('recently-viewed', JSON.stringify(newData));
          } else {
            this.show = false;
            localStorage.setItem('recently-viewed', JSON.stringify([productViewed]));
          }
        },

        getProductRecently(sectionId, productId) {
          let products = [];

          if (localStorage.getItem('recently-viewed')?.length) {
            products = JSON.parse(localStorage.getItem('recently-viewed'));
            products = productId ? [...products.filter(p => p !== productId)] : products;
            products = products.slice(0, this.productsToShow);
          } else {
            return;
          }

          const el = document.getElementById('shopify-section-recently-viewed');

          if (!el) return;

          let query = products.map(value => 'id:' + value).join(' OR ');
          var search_url = `${Shopify.routes.root}search?section_id=${sectionId}&type=product&q=${query}`;

          fetch(search_url)
            .then((response) => {
              if (!response.ok) {
                var error = new Error(response.status);
                console.log(error);
                throw error;
              }

              return response.text();
            })
            .then((text) => {
              const parsedHtml = new DOMParser().parseFromString(text, 'text/html');
              const newSection = parsedHtml.getElementById('shopify-section-recently-viewed');

              if (!newSection) return;

              el.innerHTML = newSection.innerHTML;
            })
            .catch((error) => {
              throw error;
            });
        },

        clearStory() {
          var result = confirm('Are you sure you want to clear your recently viewed products?');

          if (result === true) {
            localStorage.removeItem('recently-viewed');
            this.hideRecentlyViewed();
          }
        }
      });

      if (window.location.pathname.includes('/cart')) {
        const syncRecentlyViewedWithCart = () => {
          setTimeout(() => {
            Alpine.store('xProductRecently')?.showProductRecently();
          }, 300);

          setTimeout(() => {
            Alpine.store('xProductRecently')?.showProductRecently();
          }, 800);

          setTimeout(() => {
            Alpine.store('xProductRecently')?.showProductRecently();
          }, 1500);
        };

        syncRecentlyViewedWithCart();

        const cartContainer = document.querySelector('main') || document.body;

        const observer = new MutationObserver(() => {
          syncRecentlyViewedWithCart();
        });

        observer.observe(cartContainer, {
          childList: true,
          subtree: true
        });
      }
    });
  });
}